var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2146 1.0741H1.78606C1.39097 1.0741 1.07178 1.39329 1.07178 1.78838V18.217C1.07178 18.612 1.39097 18.9312 1.78606 18.9312H9.82178C9.91999 18.9312 10.0003 18.8509 10.0003 18.7527V17.5027C10.0003 17.4045 9.91999 17.3241 9.82178 17.3241H2.67892V2.68124H17.3218V9.8241C17.3218 9.92231 17.4021 10.0027 17.5004 10.0027H18.7504C18.8486 10.0027 18.9289 9.92231 18.9289 9.8241V1.78838C18.9289 1.39329 18.6097 1.0741 18.2146 1.0741ZM13.1544 11.9536L14.3195 10.7884C14.3432 10.7647 14.3596 10.7348 14.3671 10.7022C14.3746 10.6696 14.3727 10.6355 14.3618 10.6039C14.3509 10.5722 14.3313 10.5443 14.3053 10.5233C14.2792 10.5022 14.2478 10.4889 14.2146 10.4848L10.2102 10.0161C10.0963 10.0027 9.99812 10.0987 10.0115 10.2147L10.4803 14.2192C10.4981 14.3665 10.6789 14.429 10.7838 14.3241L11.9535 13.1545L17.6722 18.8732C17.7414 18.9424 17.8553 18.9424 17.9245 18.8732L18.8709 17.9268C18.9401 17.8576 18.9401 17.7437 18.8709 17.6745L13.1544 11.9536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.726f7a81ec947d6db596264375cfdd5b.svg";
export { ForwardRef as ReactComponent };